import { render, staticRenderFns } from "./myMenu.vue?vue&type=template&id=322300bc&scoped=true&"
import script from "./myMenu.vue?vue&type=script&lang=js&"
export * from "./myMenu.vue?vue&type=script&lang=js&"
import style0 from "./myMenu.vue?vue&type=style&index=0&id=322300bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322300bc",
  null
  
)

export default component.exports